import axiosInstance from '../../../config/axiosInstance';
import { OppurtunityValidation } from "../Views/Validation/OppurtunityValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};
const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
  event.preventDefault();
  const formErrors = OppurtunityValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      formData.formData.ClientID = CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.UserID=UserID;
       const formDataToSend = new FormData();
      
       formDataToSend.append(
        "formData",
        JSON.stringify(formData.formData)
      );

      formDataToSend.append(
        "tableData",
        JSON.stringify(
          formData.tableData.map(item => ({
            ...item,
            AttachmentFile: undefined
          }))
        )
      );

      formData.tableData.forEach((item, index) => {

        if (item.File instanceof File) {

          formDataToSend.append(
            `Attachment_${index}`,
            item.File
          );
        }
      });

      const response = await axiosInstance.post(
        `/Oppurtunity/CreateOppurtunity`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      localStorage.setItem('OpportunityID', response.data.OpportunityID);
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
  else
  {
    return "Validation required";
  }
};

export { handleChange, handleSubmit };